import { useState, useEffect,useRef } from "react";
import Box from "@mui/material/Box";
import {
  Tab,
  Tabs,
  Modal,
  Button,
  Form,
  Row,
  Col,
  Card,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import "./Css/TabCss.css";
import Axios from "axios";
import CloudConnectBackup from "./CloudConnectBackup";
import CloudConnectReplication from "./CloudConnectReplication";
import Microsoft365Backup from "./Microsoft365Backup";
import VeeamLocalBackup from "./VeeamLocalBackup";
import PricingToolHeaderBG from "../src/Images/PricingToolHeaderBG.jpg";
import "bootstrap/dist/css/bootstrap.css";
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { API_ROUTE, Routes } from "./Constants";

export default function PricingTabContent() {
  const [activeKey, setActiveKey] = useState("1");
  const [isBlurred, setIsBlurred] = useState(true);
  const [show, setShow] = useState(false);
  const [show500, setShow500] = useState(false);
  const [showRequest, setShowRequest] = useState(false);
  const [imageUrl, setImageUrl] = useState(
    "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/6.png"
  );
  const [heading, setHeading] = useState(
    <>
      <div className="Title">CloudCover Pricing Tool</div>
    </>
  );
  const [displayTab, setDisplayTab] = useState(false);

  const [qparams, setQparams] = useState(
    new URLSearchParams(window.location.search)
  );
  const [resellerId, setResellerId] = useState(0);
  const [displayOnly, setDisplayOnly] = useState(true);
  const [plan, setPlan] = useState("");
  const [planDetails, setPlanDetails] = useState([]);
  const [Terms, setTerms] = useState([]);
  const [showLoader, setShoeLoader] = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage,setToastMessage]=useState("");
  const [toastVariant,setToastVariant]=useState("");
  const [hideRRP, setHideRRP] = useState(true);
  const [requestCallSuccess, setRequestCallSuccess] = useState(false);
  const [data, setData] = useState({
    name: "",
    isNameValid: true,
    nameErrorMessage: "",
    businessEmail: "",
    phoneNumber:"",
    isBusinessValid: true,
    isPhoneNumberValid: true,

    businessEmailErrorMessage: "",
    company: "",
    isCommpanyValid: true,
    companyErrorMessage: "",
    number: "",
    isNumberValid: true,
    numberErrorMessage: "",
    phoneNumberErrorMessage:"",
    comments: "",
    isCommentsValid: true,
    commentsErrorMessage: "",
    userCount: "",
    isUserCountValid: true,
    userCountErrorMessage: "",
    selectedPlan:"",
    usersCount:0,
    contractLength:""
  });
  const [sendData, setSendData] = useState({
    name: "",
    businessEmail: "",
    phoneNumber:"",
    company: "",
    number: "",
    comments: "",
    userCount: "",
    selectedPlan:"",
    usersCounts:"",
    contractLength:"",
    url : window.location.href ? window.location.href : "NoUrl"
  });
  const dataRef = useRef(sendData);
  useEffect(() => {
    dataRef.current = sendData;
    const a = sendData.url;
  }, [sendData]);
  const [countryCode, setCountryCode] = useState('+44');
  const handleClose = () => {
    setShow(false);
    setData({
      ...data,
      isNameValid: true,
      nameErrorMessage: "",
      isBusinessValid: true,
      businessEmailErrorMessage: "",
      userCount: "",
      isUserCountValid: true,
      userCountErrorMessage: "",
      
    });
  };
    const handleClose500 = () => {
        setShow500(false);
        setData({
            ...data,
            isNameValid: true,
            nameErrorMessage: "",
            isBusinessValid: true,
            businessEmailErrorMessage: "",
            userCount: "",
            isUserCountValid: true,
            userCountErrorMessage: "",
        });
    };
  const handleShow = () => setShow(true);
    const handleShow500 = (currentPlan) => {
        setPlan(currentPlan);
        setShow500(true);
    };
  const handleRequestClose = () => setShowRequest(false);
  const handleRequestShow = () => setShowRequest(true);
  const handleRequestCallClose = () => setRequestCallSuccess(false);
  const handleRequestCallShow = () => setRequestCallSuccess(true);
  useEffect(() => {
        // Listen for messages from the iframe
        const handleMessage = (event) => {
            try{
                var value=JSON.parse(event.data)
                if(value.selectedPlan && value.users && value.length)
                {
                  setSendData({
                  ...dataRef.current,
                  selectedPlan:value.selectedPlan,
                  usersCounts:String(value.users),
                  contractLength:String(value.length)
                });
                }
                else{
                  throw new Error('Something went wrong!');
                }
            }
            catch(e){
                if(event.data == true){
                    handleShow();
                }
                else if(event.data == "planNotSelected"){
                  setToastVariant("warning");
                setToastMessage("Please select a package");
                setShowToast(true);
                }
                else if(event.data == "RequestCall"){
                    RequestCallAPI();
                }
            }
            if(event.data == true){
                handleShow();
            }
            else if(event.data == "planNotSelected"){
              setToastVariant("warning");
            setToastMessage("Please select a package");
            setShowToast(true);
            }
            // Handle the received message (event.data)
        };

        window.addEventListener('message', handleMessage);

        // Cleanup when the component unmounts
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    
const RequestCallAPI = () => {
    let service = "";
  if (activeKey === "1") {
    service = "Veeam Cloud Connect Backup";
  } else if (activeKey === "2") {
    service = "Veeam Cloud Connect Replication";
  } else if (activeKey === "3") {
    service = "Microsoft 365 Backup";
  } else {
    service = "Veeam Local Backup";
  }

  const url = (dataRef.current.url && dataRef.current.url.trim() === "") ? "NoUrl" : dataRef.current.url
  const name = (dataRef.current.name && dataRef.current.name.trim() === "") ? "NoName" : dataRef.current.name
  const email = (dataRef.current.businessEmail && dataRef.current.businessEmail.trim() === "") ? "NoEmail" : dataRef.current.businessEmail
  const phoneNumber = (dataRef.current.phoneNumber && dataRef.current.phoneNumber.trim() === "") ? "NoNumber" : dataRef.current.phoneNumber
  const selectedPlan = (dataRef.current.selectedPlan.trim() === "") ? "NoPlanSelected" : dataRef.current.selectedPlan 
  const userCount = (dataRef.current.usersCounts.trim() === "") ? "NoUsers" : dataRef.current.usersCounts
  const contractLength = (dataRef.current.contractLength.trim() === "") ? "NoContract" : dataRef.current.contractLength
  handleRequestCallShow();
  const requestCall =
    `${API_ROUTE}${Routes.GET_VIEW_PRICEMODEL}/${name}/${email}/${phoneNumber}/${encodeURIComponent(service)}/${encodeURIComponent(selectedPlan)}/${userCount}/${contractLength}/${encodeURIComponent(url)}`;
   fetch(requestCall, {
    method: 'GET',
    keepalive: true,
    headers: {
      'Authorization': 'Bearer Token not needed for Display only',
    },
  })
    .then((response) => {
      ////response.json();
      
    })
    .catch((error) => console.log("API call error", error));
};
     useEffect(() => {
  
const handleBeforeUnload = (event) => {
    let service = "";
  if (activeKey === "1") {
    service = "Veeam Cloud Connect Backup";
  } else if (activeKey === "2") {
    service = "Veeam Cloud Connect Replication";
  } else if (activeKey === "3") {
    service = "Microsoft 365 Backup";
  } else {
    service = "Veeam Local Backup";
  }

  const url = (dataRef.current.url && dataRef.current.url.trim() === "") ? "NoUrl" : dataRef.current.url
  const name = (dataRef.current.name && dataRef.current.name.trim() === "") ? "NoName" : dataRef.current.name
  const email = (dataRef.current.businessEmail && dataRef.current.businessEmail.trim() === "") ? "NoEmail" : dataRef.current.businessEmail
  const phoneNumber = (dataRef.current.phoneNumber && dataRef.current.phoneNumber.trim() === "") ? "NoNumber" : dataRef.current.phoneNumber
  const selectedPlan = (dataRef.current.selectedPlan.trim() === "") ? "NoPlanSelected" : dataRef.current.selectedPlan 
  const userCount = (dataRef.current.usersCounts.trim() === "") ? "NoUsers" : dataRef.current.usersCounts
  const contractLength = (dataRef.current.contractLength.trim() === "") ? "NoContract" : dataRef.current.contractLength

  const requestCall =
    `${API_ROUTE}${Routes.GET_VIEW_PRICEMODEL}/${name}/${email}/${phoneNumber}/${encodeURIComponent(service)}/${encodeURIComponent(selectedPlan)}/${userCount}/${contractLength}/${encodeURIComponent(url)}`;
  // console.log("selectedPlan", selectedPlan);
  // console.log("userCount", userCount);
  // console.log("contractLength", contractLength);
  // console.log("selectedPlan", dataRef.current.selectedPlan === "");
  // console.log("userCount", dataRef.current.usersCounts === "");
  // console.log("contractLength", dataRef.current.contractLength === "");
  // console.log("Request URL:", requestCall);

  fetch(requestCall, {
    method: 'GET',
    keepalive: true,
    headers: {
      'Authorization': 'Bearer Token not needed for Display only',
    },
  })
    .then((response) => response.json())
    .then((data) => console.log("API call made", data))
    .catch((error) => console.log("API call error", error));
};
  window.addEventListener("beforeunload", handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
  
 }, []);

  const togglePriceBlur = async () => {
    let config = {
      headers: {
        Authorisation: "Bearer Token not need for Display only",
      },
    };
    var service="";
    if (activeKey=="1"){
      service="Veeam Cloud Connect Backup";
    }
    else if (activeKey == "2") {
      service = "Veeam Cloud Connect Replication";
    }
    else if (activeKey == "3") {
      service = "Microsoft 365 Backup";
    }
    else{
      service = "Veeam Local Backup";
    }
    const url = qparams.get("pageURL") ? qparams.get("pageURL") : "";
      if (
        data.isNameValid &&
        data.isBusinessValid &&
        data.name !== "" &&
        data.businessEmail !== "" &&
        data.phoneNumber!==""
      ) {
        setToastVariant("success");
            setToastMessage("Successfully submitted");
            setShowToast(true);
            setIsBlurred(!isBlurred);
            handleClose();
      } else {
        setToastVariant("danger");
        setToastMessage("Please fill in all required fields.");
        setShowToast(true);
      }
    
  };
  const requestFor500Plus = async () => {
    let config = {
      headers: {
        Authorisation: "Bearer Token not need for Display only",
      },
    };
    var service="";
    if (activeKey=="1"){
      service="Veeam Cloud Connect Backup";
    }
    else if (activeKey == "2") {
      service = "Veeam Cloud Connect Replication";
    }
    else if (activeKey == "3") {
      service = "Microsoft 365 Backup";
    }
    else{
      service = "Veeam Local Backup";
    }
    const url = qparams.get("pageURL") ? qparams.get("pageURL") : "";
      if (
        data.isNameValid &&
        data.isBusinessValid &&
        data.name !== "" &&
        data.businessEmail !== "" &&
        data.phoneNumber!=="" &&
        data.userCount!=="" &&
        plan!==""
      ) {
        console.log(plan);
        const response = await Axios.get(
            API_ROUTE + Routes.GET_VIEW_PRICEMODEL_FOR500PLUS + "/" +
            data.name +
            "/" +
            data.businessEmail +
            "/" +
            data.phoneNumber +
            "/" +
            service +
            "/" +
            data.userCount +
            "/" +
            plan +
            "/" +
            url,
          config
        )
          .then((response) => {
            setToastVariant("success");
            setToastMessage("Successfully submitted");
            setShowToast(true);
            setPlan("");
          })
          .catch((reason) => {
            console.log(reason);
            if (reason == "Email is not valid.") {
              setToastVariant("danger");
              setToastMessage("Provided Email is not valid.");
              setShowToast(true);
            } else {
              setToastVariant("danger");
              setToastMessage("Email sending failed.");
              setShowToast(true);
            }
            setShoeLoader(false);
            setPlan("");
          });
      } else {
        setToastVariant("danger");
        setToastMessage("Please fill in all required fields.");
        setShowToast(true);
      }
    handleClose500();
  };

  const handleRequestSubmit = async () => {
    let config = {
      headers: {
        Authorisation: "Bearer Token not need for Display only",
      },
    };
    var service = "";
    if (activeKey == "1") {
      service = "Veeam Cloud Connect Backup";
    } else if (activeKey == "2") {
      service = "Veeam Cloud Connect Replication";
    } else if (activeKey == "3") {
      service = "Microsoft 365 Backup";
    } else {
      service = "Veeam Local Backup";
    }
    const url = qparams.get("pageURL") ? qparams.get("pageURL") : "";
    if ( data.isNameValid && data.isBusinessValid && data.isCommpanyValid && data.isNumberValid && data.isCommentsValid && data.name !== "" && data.businessEmail !== "" && data.company !== ""&& data.number !== ""&& data.comments !== ""){
        const response = await Axios.get(
            API_ROUTE + Routes.GET_TRAIL_REQUEST + "/" +
          data.name +
          "/" +
          data.businessEmail +
          "/" +
          data.company +
          "/" +
          data.number +
          "/" +
          data.comments +
          "/" +
          service +
          "/" +
          url,
        config
      )
        .then((response) => {
          setToastVariant("success");
          setToastMessage("Successfully submitted");
          setShowToast(true);
          setIsBlurred(!isBlurred);
        })
        .catch((reason) => {
          console.log(reason);
          if (reason == "Email is not valid.") {
            setToastVariant("danger");
            setToastMessage("Provided Email is not valid.");
            setShowToast(true);
          } else {
            setToastVariant("danger");
            setToastMessage("Email sending failed.");
            setShowToast(true);
          }
          setShoeLoader(false);
        });
    }
    else{
      setToastVariant("danger")
      setToastMessage('Please fill in all required fields.')
      setShowToast(true);
    }
    handleRequestClose();
  };
  const handleSelect = (key) => {
    setActiveKey(key);
    if (key === "1") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/2.png"
      );
      setHeading(
        <>
          <div className="Title">Veeam Cloud Connect Backup</div>
          <div className="SubTitle">Off Site Backup & Air Gap</div>
        </>
      );
    } else if (key === "2") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/5.png"
      );
      setHeading(
        <>
          <div className="Title">Veeam Cloud Connect Replication</div>
          <div className="SubTitle">Off Site Replication and Failover</div>
        </>
      );
    } else if (key === "3") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/4.png"
      );
      setHeading(
        <>
          <div className="Title">CloudCover 365</div>
          <div className="SubTitle">Back up your Microsoft Office 365</div>
        </>
      );
    } else if (key === "4") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/3.png"
      );
      setHeading(
        <>
          <div className="Title">Veeam Local Backup</div>
          <div className="SubTitle">
            The complete on site & off site backup solution
          </div>
        </>
      );
    }
  };
  const handleNameChange = (params) => {
    if (params.target.value.trim() !== "") {
      setData({
        ...data,
        name: params.target.value,
        isNameValid: true,
        nameErrorMessage: "",
      });
      setSendData({
        ...sendData,
        name: params.target.value,
      });
    } else {
      setData({
        ...data,
        name: params.target.value,
        isNameValid: false,
        nameErrorMessage: "Name should not be empty",
      });
    }
    };
    const countryList = [
        { name: "US", code: "+1" },
        { name: "UK", code: "+44" },
        { name: "India", code: "+91" },
        { name: "Canada", code: "+1" },
        { name: "Australia", code: "+61" },
        { name: "Germany", code: "+49" },
        { name: "France", code: "+33" },
        { name: "Brazil", code: "+55" },
        { name: "South Africa", code: "+27" },
        { name: "Japan", code: "+81" },
    ];
  const bannedDomains = [
    "aol.com",
    "facebook.com",
    "gmail.com",
    "googlemail.com",
    "google.com",
    "hotmail.com",
    "hotmail.co.uk",
    "mac.com",
    "me.com",
    "mail.com",
    "msn.com",
    "yahoo.com",
    "yahoo.co.uk",
    "ymail.com",
    "protonmail.com",
    "bob.com",
    "outlook.com",
    "zoho.com",
    "gmx.com",
    "tutanota.com",
    "yandex.com",
    "icloud.com",
    "fastmail.com",
    "hushmail.com",
    "runbox.com",
    "posteo.de",
    "lycos.com",
    "inbox.com",
    "bluemail.me",
    "10minutemail.com",
    "guerrillamail.com",
    "mailinator.com",
    "btinternet.com",
    "hotmail.fr",
    "yahoo.fr",
    "wanadoo.fr",
    "orange.fr",
    "comcast.net",
    "yahoo.com.br",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "free.fr",
    "gmx.de",
    "web.de",
    "yandex.ru",
    "ymail.com",
    "libero.it",
    "uol.com.br",
    "bol.com.br",
    "mail.ru",
    "cox.net",
    "hotmail.it",
    "sbcglobal.net",
    "sfr.fr",
    "live.fr",
    "verizon.net",
    "live.co.uk",
    "yahoo.es",
    "ig.com.br",
    "live.nl",
    "bigpond.com",
    "terra.com.br",
    "yahoo.it",
    "neuf.fr",
    "yahoo.de",
    "alice.it",
    "rocketmail.com",
    "att.net",
    "laposte.net",
    "bellsouth.net",
    "yahoo.in",
    "hotmail.es",
    "charter.net",
    "yahoo.ca",
    "yahoo.com.au",
    "rambler.ru",
    "hotmail.de",
    "tiscali.it",
    "shaw.ca",
    "yahoo.co.jp",
    "sky.com",
    "earthlink.net",
    "optonline.net",
    "freenet.de",
    "t-online.de",
    "aliceadsl.fr",
    "virgilio.it",
    "home.nl",
    "qq.com",
    "telenet.be",
    "yahoo.com.ar",
    "tiscali.co.uk",
    "yahoo.com.mx",
    "voila.fr",
    "gmx.net",
    "planet.nl",
    "tin.it",
    "live.it",
    "ntlworld.com",
    "arcor.de",
    "yahoo.co.id",
    "frontiernet.net",
    "hetnet.nl",
    "live.com.au",
    "yahoo.com.sg",
    "zonnet.nl",
    "club-internet.fr",
    "juno.com",
    "optusnet.com.au",
    "blueyonder.co.uk",
    "bluewin.ch",
    "skynet.be",
    "sympatico.ca",
    "windstream.net",
    "centurytel.net",
    "chello.nl",
    "live.ca",
    "aim.com",
    "bigpond.net.au",
  ];
  const isValidEmailAddress = (address) => {
    const regEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      
  
      if (!regEmail.test(address)) {
          return false;
      }
  
      const domain = address.split('@')[1];
      if (bannedDomains.includes(domain)) {
          return false;
      }
  
      return true;
  };
  const handleBusiness = (params) => {
    const domain = params.target.value.split('@')[1];
    if (
      params.target.value !== "" &&
      isValidEmailAddress(params.target.value)
    ) {
      setData({
        ...data,
        businessEmail: params.target.value,
        isBusinessValid: true,
        businessEmailErrorMessage: "",
      });
      setSendData({
        ...sendData,
        businessEmail: params.target.value
      });
    } else {
      if (params.target.value === "") {
        setData({
          ...data,
          businessEmail: params.target.value,
          isBusinessValid: false,
          businessEmailErrorMessage: "Business Email should not be empty",
        });
      } 
      else if(bannedDomains.includes(domain)){
        setData({
          ...data,
          businessEmail: params.target.value,
          isBusinessValid: false,
          businessEmailErrorMessage: "This is not a valid Business Email address",
        });
      }
      else {
        setData({
          ...data,
          businessEmail: params.target.value,
          isBusinessValid: false,
          businessEmailErrorMessage: "Email provided is not valid",
        });
      }
    }
  };
  const handleCompany = (params) => {
    if (params.target.value.trim() !== "") {
      setData({
        ...data,
        company: params.target.value,
        isCommpanyValid: true,
        companyErrorMessage: "",
      });
      setSendData({
        ...sendData,
        company: params.target.value
      });
    } else {
      setData({
        ...data,
        company: params.target.value,
        isCommpanyValid: false,
        companyErrorMessage: "Company Name should not be empty",
      });
    }
  };
  const handleNumber = (params) => {
      const input = params.target.value;
      const fullPhoneNumber = countryCode + input;
      if (input !== "" && isValidPhoneNumber(fullPhoneNumber)) {
      setData({
        ...data,
        number: params.target.value,
        isNumberValid: true,
        numberErrorMessage: "",
      });
      setSendData({
        ...sendData,
        number: params.target.value
      });
    } else {
      setData({
        ...data,
        number: params.target.value,
        isNumberValid: false,
          numberErrorMessage: "Phone Number is Invalid",
      });
    }
  };
  const handlePhoneNumber = (params) => {
    const input = params.target.value;
    const fullPhoneNumber = countryCode + input;
    if (input.trim() !== "" && isValidPhoneNumber(fullPhoneNumber)) {
      setData({
        ...data,
        phoneNumber: params.target.value,
        isPhoneNumberValid: true,
        phoneNumberErrorMessage: "",
      });
      setSendData({
        ...sendData,
        phoneNumber: params.target.value
      });
    } else {
      setData({
        ...data,
        phoneNumber: params.target.value,
        isPhoneNumberValid: false,
        phoneNumberErrorMessage: "Phone Number is Invalid",
      });
    }
  };

    const handleCountryCodeChange = (e) => {
        const selectedCode = e.target.value;
        setCountryCode(selectedCode);
        setData({ ...data, phoneNumber: '',number:'' });
    };

  const handleUserCount = (params) => {
        if (Number(params.target.value) > 500) {
            setData({
                ...data,
                userCount: params.target.value,
                isUserCountValid: true,
                userCountErrorMessage: "",
            });
            setSendData({
                ...sendData,
                userCount: params.target.value
            });
        } else {
            setData({
                ...data,
                userCount: params.target.value,
                isUserCountValid: false,
                userCountErrorMessage: "User Count should be greater than 500",
            });
        }
    };
  const handleComments = (params) => {
    if (params.target.value !== "") {
      setData({
        ...data,
        comments: params.target.value,
        isCommentsValid: true,
        commentsErrorMessage: "",
      });
      setSendData({
        ...sendData,
        comments: params.target.value
      });
    } else {
      setData({
        ...data,
        comments: params.target.value,
        isCommentsValid: false,
        commentsErrorMessage: "Comments should not be empty",
      });
    }
  };
  const handleCardClick = (tabkey) => {
    setActiveKey(tabkey);
    setDisplayTab(true);
    if (tabkey === "1") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/2.png"
      );
      setHeading(
        <>
          <div className="Title">Veeam Cloud Connect Backup</div>
          <div className="SubTitle">Off Site Backup & Air Gap</div>
        </>
      );
    } else if (tabkey === "2") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/5.png"
      );
      setHeading(
        <>
          <div className="Title">Veeam Cloud Connect Replication</div>
          <div className="SubTitle">Off Site Replication and Failover</div>
        </>
      );
    } else if (tabkey === "3") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/4.png"
      );
      setHeading(
        <>
          <div className="Title">CloudCover 365</div>
          <div className="SubTitle">Back up your Microsoft Office 365</div>
        </>
      );
    } else if (tabkey === "4") {
      setImageUrl(
        "https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/3.png"
      );
      setHeading(
        <>
          <div className="Title">Veeam Local Backup</div>
          <div className="SubTitle">
            The complete on site & off site backup solution
          </div>
        </>
      );
    }
  };

  useEffect(() => {
    const tabActiveKey = qparams.get("prod") ? qparams.get("prod") : "";
    if (tabActiveKey !== "") {
      setActiveKey(tabActiveKey);
      setDisplayTab(true);
    }
  }, []);

  return (
    <>
      <Box sx={{ width: "100%", typography: "body1"}} className="app-main p-3">
        <Row
          className="m-1 mb-3"
          style={{
            borderRadius: "8px",
            backgroundImage: `url(${PricingToolHeaderBG})`,
            backgroundPosition: "top center",
            backgroundSize: "cover",
          }}
        >
          <Col sm={12} className="p-2" id="header">
            <div className="d-flex justify-content-around align-items-center mb-3">
              <img
                alt="virtualdcs"
                src={imageUrl}
                style={{ height: "130px" }}
                className="header_img"
              ></img>
              <Col sm={6}>{heading}</Col>
              <img
                src="https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/1.png"
                alt="veeam"
                style={{ height: "130px" }}
                className="header_img"
              ></img>
            </div>
          </Col>
        </Row>
        {displayTab ? (
          <Tabs
            defaultActiveKey="1"
            id="justify-tab-example"
            className=""
            justify
            activeKey={activeKey}
            onSelect={handleSelect}
          >
            <Tab eventKey="1" title="Veeam Cloud Connect Backup">
              <CloudConnectBackup
                isBlurred={isBlurred}
                handleShow={handleShow}
                handleRequestShow={handleRequestShow}
              />
            </Tab>
            <Tab eventKey="2" title="Veeam Cloud Connect Replication">
              <CloudConnectReplication
                isBlurred={isBlurred}
                handleShow={handleShow}
                handleRequestShow={handleRequestShow}
                handleCardClick={handleCardClick}
              />
            </Tab>
            <Tab
              eventKey="3"
              title="Microsoft 365 Backup"
              style={{
                overflowX: "hidden",
                overflowY: "auto",
                maxHeight: "calc(70vh - -21px)",
              }}
            >
              <Microsoft365Backup
                isBlurred={isBlurred}
                handleRequestShow={handleRequestShow}
              />
            </Tab>
            <Tab eventKey="4" title="Veeam Local Backup">
              <VeeamLocalBackup
                isBlurred={isBlurred}
                handleShow={handleShow}
                handleRequestShow={handleRequestShow}
              />
            </Tab>
          </Tabs>
        ) : (
          <Row>
            <Col sm={6} className="pb-3" onClick={() => handleCardClick("1")}>
              <div
                className="p-2"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #6dd6eb, #0c33a6)",
                  borderRadius: "13px",
                  width: "100%",
                }}
              >
                <Card>
                  <Card.Body>
                    <img
                      style={{
                        height: "15rem",
                        filter: "drop-shadow(2px 4px 10px white)",
                      }}
                      className="tab-img"
                      alt="cloudcover-backup"
                      src="https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/cloudcover-backup.png"
                    />
                  </Card.Body>
                </Card>
              </div>
            </Col>
            <Col sm={6} className="pb-3" onClick={() => handleCardClick("2")}>
              <div
                className="p-2"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #6dd6eb, #0c33a6)",
                  borderRadius: "13px",
                  width: "100%",
                }}
              >
                <Card>
                  <Card.Body>
                    <img
                      style={{
                        height: "15rem",
                        filter: "drop-shadow(2px 4px 10px white)",
                      }}
                      className="tab-img"
                      alt="cloudcover-backup"
                      src="https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/cloudcover-replication.png"
                    />
                  </Card.Body>
                </Card>
              </div>
            </Col>
            <Col sm={6} onClick={() => handleCardClick("3")} className="pb-3">
              <div
                className="p-2"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #6dd6eb, #0c33a6)",
                  borderRadius: "13px",
                  width: "100%",
                }}
              >
                <Card>
                  <Card.Body>
                    <img
                      style={{
                        height: "15rem",
                        filter: "drop-shadow(2px 4px 10px white)",
                      }}
                      className="tab-img"
                      alt="cloudcover-backup"
                      src="https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/CloudCover-365-logo.jpg"
                    />
                  </Card.Body>
                </Card>
              </div>
            </Col>
            <Col sm={6} onClick={() => handleCardClick("4")}>
              <div
                className="p-2"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #6dd6eb, #0c33a6)",
                  borderRadius: "13px",
                  width: "100%",
                }}
              >
                <Card>
                  <Card.Body>
                    <img
                      style={{
                        height: "15rem",
                        filter: "drop-shadow(2px 4px 10px white)",
                      }}
                      className="tab-img"
                      alt="cloudcover-backup"
                      src="https://resources.virtualdcs.co.uk/hubfs/pricing-tool-images/CloudCover-local.png"
                    />
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        )}
      </Box>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Access Pricing Tools</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Name <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Name"
              isInvalid={!data.isNameValid}
              value={data.name}
              onChange={handleNameChange}
            />
            <Form.Control.Feedback type="invalid">
              {data.nameErrorMessage}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>
              Business Email <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="Business Email"
              isInvalid={!data.isBusinessValid}
              value={data.businessEmail}
              onChange={handleBusiness}
            />
            <Form.Control.Feedback type="invalid">
              {data.businessEmailErrorMessage}
            </Form.Control.Feedback>

          </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>
                          Phone Number <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <div className="row">
              <div className="col-3 pe-0">
                <Form.Select
                              value={countryCode}
                              onChange={handleCountryCodeChange}
                          >
                              {countryList.map((country) => (
                                  <option key={country.code} value={country.code}>
                                      ({country.code}){country.name}
                                  </option>
                              ))}
                          </Form.Select>
              </div>
              <div className="col-9"> 
                  <Form.Control
                              type="number"
                              placeholder="Phone Number"
                              isInvalid={!data.isPhoneNumberValid}
                              value={data.phoneNumber}
                              onChange={handlePhoneNumber}
                          />
                  <Form.Control.Feedback type="invalid">
                          {data.phoneNumberErrorMessage}
                      </Form.Control.Feedback>
              </div> 
              <div className="col-12"> 
                  
              </div>
            </div>
                      
                  </Form.Group>

          <Form.Text
            className="text-muted"
            style={{ fontSize: "10px", lineHeight: "0" }}
          >
            Your form submission is subject to our company’s{" "}
            <a href="https://www.virtualDCS.co.uk/privacy/" target="_blank">
              {" "}
              privacy policy.
            </a>{" "}
            By providing your information on this page you are consenting to opt
            in to virtualDCS’ use of your details to contact you regarding the
            products and services that we offer.
          </Form.Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ color: "#5191ce", background: "white" }}
            onClick={() => {
              togglePriceBlur();
            }}
          >
            Access Pricing Tools
          </Button>
        </Modal.Footer>
          </Modal>
          <Modal
              show={show500}
              onHide={handleClose500}
              backdrop="static"
              keyboard={false}
          >
              <Modal.Header closeButton>
                  <Modal.Title>Access Pricing Tools For 500+ Users</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>
                          Name <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                          type="text"
                          placeholder="Name"
                          isInvalid={!data.isNameValid}
                          value={data.name}
                          onChange={handleNameChange}
                      />
                      <Form.Control.Feedback type="invalid">
                          {data.nameErrorMessage}
                      </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>
                          Business Email <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                          type="email"
                          placeholder="Business Email"
                          isInvalid={!data.isBusinessValid}
                          value={data.businessEmail}
                          onChange={handleBusiness}
                      />
                      <Form.Control.Feedback type="invalid">
                          {data.businessEmailErrorMessage}
                      </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>
                          Phone Number <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <div className="d-flex">
                          <Form.Select
                              style={{ width: '35%', marginRight: '10px' }}
                              value={countryCode}
                              onChange={handleCountryCodeChange}
                          >
                              {countryList.map((country) => (
                                  <option key={country.code} value={country.code}>
                                      ({country.code}) {country.name}
                                  </option>
                              ))}
                          </Form.Select>
                      <Form.Control
                          type="number"
                          placeholder="Phone Number"
                          isInvalid={!data.isPhoneNumberValid}
                          value={data.phoneNumber}
                          onChange={handlePhoneNumber}
                          />
                      </div>
                      <Form.Control.Feedback type="invalid">
                          {data.phoneNumberErrorMessage}
                      </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>
                          User Count <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                          type="number"
                          placeholder="Number of Users"
                          isInvalid={!data.isUserCountValid}
                          value={data.userCount}
                          onChange={handleUserCount}
                      />
                      <Form.Control.Feedback type="invalid">
                          {data.userCountErrorMessage}
                      </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Text
                      className="text-muted"
                      style={{ fontSize: "10px", lineHeight: "0" }}
                  >
                      Your form submission is subject to our company’s{" "}
                      <a href="https://www.virtualDCS.co.uk/privacy/" target="_blank">
                          {" "}
                          privacy policy.
                      </a>{" "}
                      By providing your information on this page you are consenting to opt
                      in to virtualDCS’ use of your details to contact you regarding the
                      products and services that we offer.
                  </Form.Text>
              </Modal.Body>
              <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose500}>
                      Close
                  </Button>
                  <Button
                      style={{ color: "#5191ce", background: "white" }}
                      onClick={() => {
                          requestFor500Plus();
                      }}
                  >
                      Access Pricing Tools For 500+ 
                  </Button>
              </Modal.Footer>
          </Modal>

      <Modal
        show={showRequest}
        onHide={handleRequestClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Request a Free Trial</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label>
              Name <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              isInvalid={!data.isNameValid}
              value={data.name}
              onChange={handleNameChange}
            />
            <Form.Control.Feedback type="invalid">
              {data.nameErrorMessage}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Email address <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              isInvalid={!data.isBusinessValid}
              value={data.businessEmail}
              onChange={handleBusiness}
            />
            <Form.Control.Feedback type="invalid">
              {data.businessEmailErrorMessage}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicCompany">
            <Form.Label>
              Company <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter company name"
              isInvalid={!data.isCommpanyValid}
              value={data.company}
              onChange={handleCompany}
            />
            <Form.Control.Feedback type="invalid">
              {data.companyErrorMessage}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicCompany">
            <Form.Label>
              Phone number <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <div className="row">
              <div className="col-3 pe-0">
                <Form.Select
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                >
                    {countryList.map((country) => (
                        <option key={country.code} value={country.code}>
                            ({country.code}){country.name}
                        </option>
                    ))}
                </Form.Select>
              </div>
              <div className="col-9"> 
                  <Form.Control type="number" placeholder="Enter phone number" 
                  isInvalid={!data.isNumberValid} value={data.number} onChange={handleNumber} /> 
                  <Form.Control.Feedback type="invalid"> {data.numberErrorMessage} </Form.Control.Feedback> 
              </div> 
              <div className="col-12"> 
                  
              </div>
            </div>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.Comments">
            <Form.Label>
              Comments <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              isInvalid={!data.isCommentsValid}
              value={data.comments}
              onChange={handleComments}
            />
            <Form.Control.Feedback type="invalid">
              {data.commentsErrorMessage}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleRequestClose}>
            Close
          </Button>
          <Button
            style={{ color: "#5191ce", background: "white" }}
            onClick={() => {
              handleRequestSubmit();
            }}
          >
            Request Trial
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={requestCallSuccess}
        onHide={handleRequestCallClose}
        backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{padding:'1.5rem' ,border:'5px solid #5191ce',borderRadius:'5px'}}
      >
        <Modal.Body>
          <span style={{fontSize:'1.5rem',fontWeight:'400'}}>Thank you for your enquiry, our sales team will be in touch shortly.</span>
          <div className="d-flex justify-content-center mt-3">
            <Button 
                      style={{ background: "#5191ce", color: "white" }}
                      onClick={() => {
                          handleRequestCallClose();
                      }}
                  >
                      Close
                  </Button>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer
        className="p-3"
        position="top-end"
        style={{ zIndex: 10000 }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          className="d-inline-block m-1"
          bg={toastVariant}
          autohide
          delay={4000}
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">
              {toastVariant === "danger" ? "Error" : toastVariant === "warning" ? "Warning" : "Success"}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}
